import { Messages } from './messages';
import { Observable, AsyncSubject } from 'rxjs';


export class ActionButtonSubmit {

    constructor(public action: any) {}
    private subject: AsyncSubject<any>;

    setup(): Observable<any> {
        this.subject = new AsyncSubject();
        return this.subject;
    }

    messages(messages: Messages): void {
        this.subject.next(messages);
        this.subject.complete();
    }

    result(result: any): void {
        this.subject.next(result);
        this.subject.complete();
    }
}
